export default __webpack_public_path__ + "static/media/room-zen.1480328e.png";